import { useSelector } from 'react-redux';

const useFeature = featureName => {
  const features = useSelector(state => state?.getIn(['entities', 'features']));

  return features?.getIn([featureName, 'active'], false);
};

export default useFeature;
